import { call, put, take } from 'redux-saga/effects';
import { createUploadFileChannel } from './createUploadChannel';
import { singleRCFileUploadProgressAction } from '../../actions';
import { FileUploadStatus } from '../../enums';
export const singleRCFileUploadProgressSaga = function* (documentUrl, fileId, file, isDisableProgressNotification) {
    const uploadFileChannel = yield call(createUploadFileChannel, documentUrl, file);
    while (true) {
        const { progress = 0, status } = yield take(uploadFileChannel);
        switch (status) {
            case FileUploadStatus.FAILED:
                throw new Error('File upload failed');
            case FileUploadStatus.SUCCESS:
                return;
            case FileUploadStatus.IN_PROGRESS:
                if (!isDisableProgressNotification) {
                    yield put(singleRCFileUploadProgressAction({ id: fileId, progress: progress }));
                }
        }
    }
};
//# sourceMappingURL=singleRCFileUploadProgressSaga.js.map